class Scroller {
    #hrefSelector: string = this.#getHrefSelector();

    listenToDocumentClicks() {
        document.addEventListener('click', event => {
            this.#handleDocumentClick(event);
        });
    }

    scrollToWindowLocationHashOnLoad() {
        try {
            const URLHash = window.location.hash;
            if (URLHash) {
                const scrollTarget = document.querySelector(URLHash);
                if (scrollTarget) {
                    window.addEventListener('load', () => {
                        this.#scrollToElement(scrollTarget);
                    });
                }
            }
        } catch {
            /*
                That means the URLHash is not a valid selector so we can't use it inside querySelector - it may contain things like "| ~ ! \ /"
                for this reason no need to catch the error or log it, we'll just return false.
            */
            return false;
        }
    }

    #handleDocumentClick(event: Event) {
        const target = event.target;
        let anchor: HTMLAnchorElement | null = null;
        if (target instanceof HTMLAnchorElement) {
            anchor = target;
        }
        if (target instanceof HTMLElement) {
            const parentAnchor = target.closest<HTMLAnchorElement>('a[href]');
            parentAnchor && (anchor = parentAnchor);
        }
        if (
            anchor?.matches(this.#hrefSelector) &&
            location.pathname.replace(/^\//, '') == anchor.pathname.replace(/^\//, '') &&
            location.hostname == anchor.hostname
        ) {
            const scrollTarget = document.querySelector(anchor.hash);

            if (scrollTarget) {
                event.preventDefault();
                this.#scrollToElement(scrollTarget);
            }
        }
    }

    #scrollToElement(element: Element) {
        const navEl =
            document.querySelector<HTMLElement>('.main-site-header') ??
            document.querySelector<HTMLElement>('.main-site-header-btf');

        const scrollOffset = navEl && navEl.offsetHeight > 0 ? navEl.offsetHeight : 66; // assumes height of nav is 66px if something goes wrong

        window.scrollTo({
            top:
                element.getBoundingClientRect().top +
                document.documentElement.scrollTop -
                scrollOffset,
            behavior: 'smooth',
        });
    }

    #getHrefSelector() {
        const stringsExcludedAnywhereInHref = [
            'lightbox|',
            'lightbox%7C',
            '#chat-open',
            'email-hook|',
        ];
        const hrefSelectorSubStrings = [
            "a[href*='#']:not([href='#']):not([href|='#tab'])",
        ];
        stringsExcludedAnywhereInHref.forEach(function (string) {
            const newSubString = `:not([href*='${string}'])`;
            hrefSelectorSubStrings.push(newSubString);
        });
        return hrefSelectorSubStrings.join('');
    }
}

export default function anchorsScrolling() {
    const s = new Scroller();
    s.listenToDocumentClicks();
    s.scrollToWindowLocationHashOnLoad();
}
